import { BKJIcon } from '@bookjane2/bookjane-design-library';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TableSortWrapper } from './BKJTableSubHeader.styled';
import { BKJTableDirectionIconProps, IDirectionType } from './BKJTableSubHeader.types';

const LABEL_KEY_BY_DIRECTION: Record<IDirectionType, string> = {
  default: 'accessibility:SORT_BY_COLUMN',
  asc: 'accessibility:SORT_BY_COLUMN_ASCENDING',
  desc: 'accessibility:SORT_BY_COLUMN_DESCENDING',
};

export const BKJTableDirectionIcon: React.FC<BKJTableDirectionIconProps> = ({
  direction,
  name,
  onClick,
  label,
}): JSX.Element => {
  const { t } = useTranslation();
  const ariaLabel = t(LABEL_KEY_BY_DIRECTION[direction], { column: label });

  return (
    <TableSortWrapper name={name} value={direction} onClick={onClick} aria-label={ariaLabel}>
      {direction === 'asc' && <BKJIcon iconName="CombinedChevronUp" aria-hidden="true" />}
      {direction === 'desc' && <BKJIcon iconName="CombinedChevronDown" aria-hidden="true" />}
      {direction === 'default' && <BKJIcon iconName="CombinedChevronDefault" aria-hidden="true" />}
    </TableSortWrapper>
  );
};
